<template>
  <div class="filters-section" v-if="availableThemes.length > 0">
    <div class="filter-group">
      <div class="filter-title">
        <b-icon icon="tag"></b-icon>
        {{ $t('sidebar.themes') }}
        <span class="filter-actions">
          <a href="#" @click.prevent="selectAll">{{ $t('sidebar.all') }}</a>
          <span class="separator">/</span>
          <a href="#" @click.prevent="selectNone">{{ $t('sidebar.none') }}</a>
        </span>
      </div>
      <div class="filter-options">
        <label
          v-for="theme in availableThemes"
          :key="theme.uuid"
          class="filter-option"
          :class="{ 'is-checked': isSelected(theme) }"
        >
          <input
            type="checkbox"
            :checked="isSelected(theme)"
            @change="toggleTheme(theme)"
          />
          <span>{{ theme.name }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThemeFilter',

  props: {
    availableThemes: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    selectedThemes() {
      return this.$store.state.selectedThemes
    }
  },

  methods: {
    isSelected(theme) {
      return this.selectedThemes.includes(theme.uuid)
    },

    toggleTheme(theme) {
      this.$store.dispatch('toggleSelectedTheme', theme.uuid)
      this.$emit('filter-changed')
    },

    selectAll() {
      const allThemeUuids = this.availableThemes.map(t => t.uuid)
      this.$store.dispatch('setSelectedThemes', allThemeUuids)
      this.$emit('filter-changed')
    },

    selectNone() {
      this.$store.dispatch('setSelectedThemes', [])
      this.$emit('filter-changed')
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-actions {
  margin-left: auto;
  font-size: 0.8rem;
  font-weight: 400;
  text-transform: none;

  a {
    color: #1A1A1A;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .separator {
    margin: 0 0.25rem;
    color: #999;
  }
}
</style>
